import { render, staticRenderFns } from "./block-claims-repairer.vue?vue&type=template&id=78c810f8&scoped=true"
import script from "./block-claims-repairer.vue?vue&type=script&lang=js"
export * from "./block-claims-repairer.vue?vue&type=script&lang=js"
import style0 from "./block-claims-repairer.vue?vue&type=style&index=0&id=78c810f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c810f8",
  null
  
)

export default component.exports